import React from "react";

export function parseBoldText(text) {
  const parts = text.split(/(<b>|<\/b>)/g); // separamos por las etiquetas
  let isBold = false;

  return parts.map((part, index) => {
    if (part === "<b>") {
      isBold = true;
      return null;
    }
    if (part === "</b>") {
      isBold = false;
      return null;
    }
    return isBold ? (
      <strong key={index}>{part}</strong>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    );
  });
}

export function getValueByKey(objArray, searchKey, searchValue, returnKey) {
  const found = objArray.find(item => item[searchKey] === searchValue);
  return found ? found[returnKey] : undefined;
}


export function getTextFromChildren(children: React.ReactNode): string {
  let out = '';
  React.Children.forEach(children, (child) => {
    if (typeof child === 'string' || typeof child === 'number') {
      out += String(child);
    } else if (Array.isArray(child)) {
      out += getTextFromChildren(child);
    } else if (React.isValidElement(child)) {
      out += getTextFromChildren(child.props?.children);
    }
  });
  return out.replace(/\s+/g, ' ').trim();
}

export function toSnakeCase(label: string): string {
  return label
    .toLowerCase()
    .normalize('NFC')
    .replace(/\(.*?\)|\[.*?\]|\{.*?\}/g, '')
    .replace(/[^\p{L}\p{N}]+/gu, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function toSnakeCaseNoAccents(label: string): string {
  const noDiacritics = label
    .normalize('NFD')
    .replace(/[\u0300-\u036f\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/g, '');

  return noDiacritics
    .toLowerCase()
    .replace(/\(.*?\)|\[.*?\]|\{.*?\}/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
}